import { createAsyncThunk } from '@reduxjs/toolkit';
import type {
  CreateBookingParams,
  CreateBookingResponse,
  CancelBookingParams,
  CancelBookingResponse,
  BookingError,
  UpdateBookingQuantityResponse,
  UpdateBookingQuantityParams,
  PayWithSubscriptionParams,
  PayWithSubscriptionResponse,
} from '../api/booking.types';
import { axiosInstance } from '@/shared/api/instance';

export const createBooking = createAsyncThunk<
  CreateBookingResponse,
  CreateBookingParams,
  { rejectValue: BookingError }
>('booking/create', async (params, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance.post<CreateBookingResponse>(
      '/app/bookings/create',
      null, 
      { params }, 
    );
    return data;
  } catch (error: any) {
    return rejectWithValue({
      code: error.response?.status || 500,
      message: error.response?.data?.message || 'Failed to create booking',
    });
  }
});

export const cancelBooking = createAsyncThunk<
  CancelBookingResponse,
  CancelBookingParams,
  { rejectValue: BookingError }
>('booking/cancel', async (params, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance.post<CancelBookingResponse>(
      '/app/bookings/cancel',
      null, 
      { params }, 
    );
    return data;
  } catch (error: any) {
    return rejectWithValue({
      code: error.response?.status || 500,
      message: error.response?.data?.message || 'Failed to cancel booking',
    });
  }
});

export const updateBookingQuantity = createAsyncThunk<
  UpdateBookingQuantityResponse,
  UpdateBookingQuantityParams,
  { rejectValue: BookingError }
>('booking/updateQuantity', async (params, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance.post<UpdateBookingQuantityResponse>(
      '/app/bookings/update-quantity',
      null,
      { params },
    );
    return data;
  } catch (error: any) {
    return rejectWithValue({
      code: error.response?.status || 500,
      message: error.response?.data?.message || 'Failed to update booking quantity',
    });
  }
});

export const payWithSubscription = createAsyncThunk<
  PayWithSubscriptionResponse,
  PayWithSubscriptionParams,
  { rejectValue: BookingError }
>('booking/payWithSubscription', async (params, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance.post<PayWithSubscriptionResponse>(
      '/app/bookings/pay-with-subscription',
      params,
    );
    return data;
  } catch (error: any) {
    return rejectWithValue({
      code: error.response?.status || 500,
      message: error.response?.data?.error?.message || 'Ошибка оплаты абонементом',
    });
  }
});
